import React from "react";
import { FaFacebookF, FaYoutube, FaInstagram, FaPinterest, FaWhatsapp } from "react-icons/fa";

/**
 * Official Gem Fashion Studio social profiles (order: Facebook, YouTube, Instagram, Pinterest, WhatsApp).
 * Pinterest: if your profile URL differs, update `pinterest` below.
 */
const LINKS = [
  {
    key: "facebook",
    href: "https://www.facebook.com/p/Gem-Fashion-Studio-100089753542928/",
    label: "Gem Fashion Studio on Facebook",
    Icon: FaFacebookF,
  },
  {
    key: "youtube",
    href: "https://www.youtube.com/channel/UCOg5duMCJBMS5ntklYwtW8Q",
    label: "Gem Fashion Studio on YouTube",
    Icon: FaYoutube,
  },
  {
    key: "instagram",
    href: "https://www.instagram.com/gemfashionstudio",
    label: "Gem Fashion Studio on Instagram",
    Icon: FaInstagram,
  },
  {
    key: "pinterest",
    href: "https://www.pinterest.com/gemstudiorentalboutique/",
    label: "Gem Fashion Studio on Pinterest",
    Icon: FaPinterest,
  },
  {
    key: "whatsapp",
    href: "https://api.whatsapp.com/send?phone=919372020961",
    label: "Contact us on WhatsApp",
    Icon: FaWhatsapp,
  },
];

/**
 * @param {string} [className] - e.g. social_links, newsletterSocial
 */
export default function SocialMediaLinks({ className = "" }) {
  return (
    <div className={className}>
      {LINKS.map(({ key, href, label, Icon }) => (
        <a key={key} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
          <Icon aria-hidden />
        </a>
      ))}
    </div>
  );
}
